export default "__VITE_ASSET__BNnetW8K__"